<a class="btn clear">
  <span langkey="button_back"></span>
  <div inlineSVG="sot/sot-icon.svg#sot-backward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
</a>